import React from "react";
import { Card, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, SupportRoutes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  handleAction: ActionHandlerFunction;
}

// Description: NoAddressesViewComponent is a React component that displays a card with message 
// and a button to create a user group email when the email group list is empty.
function NoAddressesViewComponent(props: AllProps) {
  const { handleAction } = props;

  return <Card className="admin-card mt-5">
    <Icon className="trusted-community" />
    <Card.Body>
      <Card.Title as="p">Create a User Group</Card.Title>
      <Card.Text as="p">
        <span className="text-muted">Learn More:</span>{" "}
        <a target="_blank" href={SupportRoutes.email_groups} rel="noreferrer">User Groups</a>
      </Card.Text>
      <Button variant="primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}>
        <Icon className="icon-plus2" />
        Create User Group
      </Button>
    </Card.Body>
  </Card>;
}

export default React.memo(NoAddressesViewComponent);
